import { render, staticRenderFns } from "./CarInsuranceUnRenewed.vue?vue&type=template&id=53586e4a"
import script from "./CarInsuranceUnRenewed.vue?vue&type=script&lang=js"
export * from "./CarInsuranceUnRenewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports